import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { api } from "../lib/api";
import { History, Loader2, Swords, Trophy } from "lucide-react";
const fmtDate = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString(undefined, { day: "numeric", month: "short" }) + " " +
      d.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" });
  } catch (e) {
    return "";
  }
};

const resultMeta = {
  win: { label: "WON", color: "#10B981", bg: "rgba(16, 185, 129,0.12)" },
  loss: { label: "LOST", color: "#EF4444", bg: "rgba(233,0,82,0.12)" },
  draw: { label: "DREW", color: "#94A3B8", bg: "rgba(184,163,202,0.12)" },
};

const HistoryModal = ({ open, onClose }) => {
  const [games, setGames] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    api.history()
      .then((d) => setGames(d.games || []))
      .catch(() => setGames([]))
      .finally(() => setLoading(false));
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="history-modal" className="theme-light w-[calc(100%-2rem)] bg-[#1E293B] border border-[#10B981]/30 text-white max-w-md p-6 max-h-[85vh] overflow-hidden flex flex-col">
        <div className="flex items-center gap-2 mb-1">
          <History className="w-5 h-5 text-[#10B981]" />
          <DialogTitle className="font-display font-extrabold text-xl">Game history</DialogTitle>
        </div>
        <DialogDescription className="text-muted-38 text-sm">Your last 50 wager and Pep games.</DialogDescription>

        <div className="mt-4 overflow-y-auto -mx-1 px-1 space-y-2">
          {loading && (
            <div className="flex justify-center py-10 text-slate-400"><Loader2 className="w-6 h-6 animate-spin" /></div>
          )}
          {!loading && games && games.length === 0 && (
            <div data-testid="history-empty" className="text-center text-muted-38 text-sm py-10">
              No games yet — wager a mate or take on Pep to start your record.
            </div>
          )}
          {!loading && games && games.map((g, i) => {
            const m = resultMeta[g.result] || resultMeta.draw;
            const coinLine = g.stake > 0
              ? (g.result === "win" ? `+£${g.stake}` : g.result === "loss" ? `-£${g.stake}` : "stake returned")
              : (g.type === "wager" ? "friendly" : "");
            return (
              <div key={i} data-testid="history-row" className="flex items-center gap-3 rounded-xl bg-black/20 border border-white/5 px-3 py-2.5">
                <div className="shrink-0 w-10 h-10 rounded-lg flex items-center justify-center" style={{ background: m.bg }}>
                  {g.type === "pep" ? <Trophy className="w-4 h-4" style={{ color: m.color }} /> : <Swords className="w-4 h-4" style={{ color: m.color }} />}
                </div>
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-semibold text-white truncate">
                    vs {g.opponent}
                    <span className="text-muted-38 font-normal"> · {g.type === "pep" ? "Pep" : "Wager"}</span>
                  </div>
                  <div className="text-xs text-muted-38">{fmtDate(g.created_at)}</div>
                </div>
                <div className="text-right shrink-0">
                  <div className="font-display font-bold text-sm" style={{ color: m.color }}>
                    {m.label} {g.my_points}–{g.their_points}
                  </div>
                  {coinLine && <div className="text-xs text-muted-38">{coinLine}</div>}
                </div>
              </div>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default HistoryModal;
